import { Tooltip } from "@mui/material";
import React, { useState } from "react";
import {
  MAX_INVESTIGATION_FILES,
  normalizeInvestigationFiles,
  canAddInvestigationFiles,
  getInvestigationFileLabel,
  appendInvestigationFiles,
  removeInvestigationFileAt,
  investigationFileInputKey,
  INVESTIGATION_UPLOAD_COLUMN_GRAY,
  INVESTIGATION_ENTRY_CLASS,
  INVESTIGATION_FILE_LIST_CLASS,
  INVESTIGATION_FILE_CHIP_CLASS,
} from "../../utils/investigationFiles";
import "../../styles/investigationUploadRows.css";

export const PainHistory4 = ({
  setPatientMedicationInfo,
  patientMedicationInfo,
}) => {
  const [haveDisabilityForPain, setHaveDisabilityForPain] = useState("No");
  const handleFileChange = (event) => {
    const { name, files } = event.target;
    if (!files?.length) return;
    setPatientMedicationInfo((prev) => ({
      ...prev,
      [name]: appendInvestigationFiles(prev[name], files),
    }));
    event.target.value = "";
  };

  const clearUploadedFile = (fieldName, index) => {
    setPatientMedicationInfo((prev) => ({
      ...prev,
      [fieldName]: removeInvestigationFileAt(prev[fieldName], index),
    }));
  };

  const renderLocalUploadButton = (fieldName) => {
    const count = normalizeInvestigationFiles(patientMedicationInfo?.[fieldName]).length;
    const canAdd = canAddInvestigationFiles(patientMedicationInfo?.[fieldName]);
    return (
      <label
        className={`flex justify-center items-center w-full rounded-lg BTNGradientBg py-2 gap-1.5 text-white ${
          canAdd ? "cursor-pointer" : "opacity-50 cursor-not-allowed"
        }`}
      >
        Upload File{count > 0 ? ` (${count}/${MAX_INVESTIGATION_FILES})` : ""}
        <input
          key={investigationFileInputKey(fieldName, patientMedicationInfo?.[fieldName])}
          name={fieldName}
          onChange={handleFileChange}
          type="file"
          multiple
          disabled={!canAdd}
          hidden
        />
      </label>
    );
  };

  const renderSelectedFileLine = (fieldName) => {
    const files = normalizeInvestigationFiles(patientMedicationInfo?.[fieldName]);
    if (!files.length) return null;
    return (
      <div className={INVESTIGATION_FILE_LIST_CLASS}>
        {files.map((entry, index) => {
          const label = getInvestigationFileLabel(entry);
          return (
            <div
              key={`${fieldName}-${index}-${label}`}
              className={`${INVESTIGATION_FILE_CHIP_CLASS} font-mainFont`}
              title={label}
            >
              <span>{label}</span>
              <button
                type="button"
                aria-label="Remove file"
                onClick={() => clearUploadedFile(fieldName, index)}
              >
                ×
              </button>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div className="px-4 py-3 mb-5 bg-white rounded shadow-sm">
      <div className="w-full">
        <div className="my-2 flex flex-col gap-8 p-6 2xl:w-[60%] xl:w-[60%] lg:w-[60%] md:w-[80%] w-full  border-b border-[#d4d4d4]">
          <p className="font-mainFont font-[600] 2xl:text-[1.3vw] xl:text-[1.3vw] lg:text-[1.3vw] md:text-[2.3vw] text-[3.5vw] text-white">
            Do you have any imaging to upload?
          </p>
          <div className="flex justify-start items-center gap-4">
            <button
              onClick={() => {
                setHaveDisabilityForPain("Yes");
                setPatientMedicationInfo({
                  ...patientMedicationInfo,
                  haveAnyImage: "Yes",
                });
              }}
              className={`text-[#333333] ${
                patientMedicationInfo.haveAnyImage === "Yes"
                  ? "text-white BTNGradientBg"
                  : "text-black bg-white"
              }  px-8 py-1 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-mainFont font-[500] rounded-full  transition-all duration-200 ease-linear shadowsForMainWrapper`}
            >
              Yes
            </button>
            <button
              onClick={() => {
                setHaveDisabilityForPain("No");
                setPatientMedicationInfo({
                  ...patientMedicationInfo,
                  haveAnyImage: "No",
                });
              }}
              className={`text-[#333333]   px-8 py-1 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-mainFont font-[500] rounded-full  transition-all duration-200 ease-linear shadowsForMainWrapper ${
                patientMedicationInfo.haveAnyImage === "No"
                  ? "text-white BTNGradientBg"
                  : "text-black bg-white"
              }`}
            >
              No
            </button>
          </div>
        </div>

        {patientMedicationInfo.haveAnyImage === "Yes" && (
          <>
            <div class="relative overflow-x-auto">
              <div className="w-full">
                <div className="flex 2xl:justify-center xl:justify-center lg:justify-center md:justify-center justify-start items-center w-full">
                  <div className="flex-1 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] flex-shrink-0  py-4 px-3">
                    <h3 className="text-[#333333] font-[600] 2xl:text-[1.4dvw] xl:text-[1.4dvw] lg:text-[1.4dvw] md:text-[1.4dvw] text-[3.5dvw] text-start">
                      Investigation
                    </h3>
                  </div>
                  <div className="flex-1 min2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] flex-shrink-0  py-4 px-3">
                    <h3 className="text-[#333333] font-[600] 2xl:text-[1.4dvw] xl:text-[1.4dvw] lg:text-[1.4dvw] md:text-[1.4dvw] text-[3.5dvw] text-start">
                      Region
                    </h3>
                  </div>
                  <div className="flex-1 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] flex-shrink-0  py-4 px-3">
                    <h3 className="text-[#333333] font-[600] 2xl:text-[1.4dvw] xl:text-[1.4dvw] lg:text-[1.4dvw] md:text-[1.4dvw] text-[3.5dvw] text-start">
                      Recent Dates
                    </h3>
                  </div>

                  <div className="flex-1 2xl:min-w-[20dvw] xl:min-w-[20dvw] lg:min-w-[20dvw] md:min-w-[20dvw] min-w-[60dvw] flex-shrink-0  py-4 px-3">
                    <h3 className="text-[#333333] font-[600] 2xl:text-[1.4dvw] xl:text-[1.4dvw] lg:text-[1.4dvw] md:text-[1.4dvw] text-[3.5dvw]vw] text-start">
                      Upload Files
                    </h3>
                  </div>
                </div>

                <div className="flex flex-col gap-3 w-full mt-4">
                  <div className={INVESTIGATION_ENTRY_CLASS}>
                  <div className="investigation-upload-row flex w-full">
                    <div className="py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] flex-shrink-0 bg-[#f0f0f0] flex-1 rounded-s-full border-2 border-[#d4d4d4] flex items-center">
                      <h3 className="text-black font-[500] 2xl:text-[1dvw] xl:text-[1dvw] lg:text-[1dvw] md:text-[1dvw] text-[3.5dvw]">MRI</h3>
                    </div>
                    <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] flex-shrink-0 border-l-0 bg-[#f0f0f0] border-2 border-[#d4d4d4] flex items-center">
                      <input
                        placeholder="Enter Region"
                        value={patientMedicationInfo.mriInfo.region}
                        onChange={(e) => {
                          setPatientMedicationInfo({
                            ...patientMedicationInfo,
                            mriInfo: {
                              region: e.target.value,
                            },
                          });
                        }}
                        className="bg-transparent border-none outline-none focus:border-none active:border-none  w-full"
                      />
                    </div>
                    <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] flex-shrink-0 border-l-0 bg-[#f0f0f0] border-2 border-[#d4d4d4] flex items-center">
                      <input
                        type="date"
                        className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                        placeholder="Enter Treatment"
                        value={patientMedicationInfo.mriInfo.date}
                        onChange={(e) => {
                          setPatientMedicationInfo({
                            ...patientMedicationInfo,
                            mriInfo: {
                              date: e.target.value,
                            },
                          });
                        }}
                      />
                    </div>

                    <div className={`${INVESTIGATION_UPLOAD_COLUMN_GRAY} flex-shrink-0`}>
                      <div className="flex justify-center items-stretch gap-2.5 w-full">
                        <Tooltip title="Create an Account and Upload images">
                          <a
                            href="https://blume.omegaai.com/"
                            target="_blank"
                            className="flex justify-center items-center w-full rounded-lg BTNGradientBg py-2 gap-1.5 text-[#fff]"
                          >
                            Upload to Blume
                          </a>
                        </Tooltip>
                        {renderLocalUploadButton("MRI_FILE")}
                        <Tooltip title="Mark as Uploaded">
                          <input
                            className="  w-7 h-7"
                            type="checkbox"
                            value="uploaded"
                            checked={patientMedicationInfo.mriInfo.isUploaded}
                            onChange={(e) => {
                              setPatientMedicationInfo({
                                ...patientMedicationInfo,
                                mriInfo: {
                                  ...patientMedicationInfo.mriInfo,
                                  isUploaded:
                                    !patientMedicationInfo.mriInfo.isUploaded,
                                },
                              });
                            }}
                          />
                        </Tooltip>
                      </div>
                    </div>
                  </div>
                  {renderSelectedFileLine("MRI_FILE")}
                  </div>

                  <div className={INVESTIGATION_ENTRY_CLASS}>
                  <div className="investigation-upload-row flex w-full">
                    <div className="py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] bg-[#f0f0f0] flex-1 rounded-s-full border-2 border-[#d4d4d4] flex items-center">
                      <h3 className="text-black font-[500] 2xl:text-[1dvw] xl:text-[1dvw] lg:text-[1dvw] md:text-[1dvw] text-[3.5dvw]">
                        CT SCAN
                      </h3>
                    </div>
                    <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] flex-shrink-0 border-l-0 bg-[#f0f0f0] border-2 border-[#d4d4d4] flex items-center">
                      <input
                        placeholder="Enter Region"
                        value={patientMedicationInfo.ctScan.region}
                        onChange={(e) => {
                          setPatientMedicationInfo({
                            ...patientMedicationInfo,
                            ctScan: {
                              region: e.target.value,
                            },
                          });
                        }}
                        className="bg-transparent border-none outline-none focus:border-none active:border-none  w-full"
                      />
                    </div>
                    <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] flex-shrink-0 border-l-0 bg-[#f0f0f0] border-2 border-[#d4d4d4] flex items-center">
                      <input
                        type="date"
                        className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                        placeholder="Enter Treatment"
                        value={patientMedicationInfo.ctScan.date}
                        onChange={(e) => {
                          setPatientMedicationInfo({
                            ...patientMedicationInfo,
                            ctScan: {
                              date: e.target.value,
                            },
                          });
                        }}
                      />
                    </div>

                    <div className={`${INVESTIGATION_UPLOAD_COLUMN_GRAY} flex-shrink-0`}>
                      <div className="flex justify-center items-stretch gap-2.5 w-full">
                        <Tooltip title="Create an Account and Upload images">
                          <a
                            href="https://blume.omegaai.com/"
                            target="_blank"
                            className="flex justify-center items-center w-full rounded-lg BTNGradientBg py-2 gap-1.5 text-[#fff]"
                          >
                            Upload to Blume
                          </a>
                        </Tooltip>
                        {renderLocalUploadButton("CT_SCAN_FILE")}
                        <Tooltip title="Mark as Uploaded">
                          <input
                            className=" w-7 h-7"
                            type="checkbox"
                            value="uploaded"
                            checked={patientMedicationInfo.ctScan.isUploaded}
                            onChange={(e) => {
                              setPatientMedicationInfo({
                                ...patientMedicationInfo,
                                ctScan: {
                                  ...patientMedicationInfo.ctScan,
                                  isUploaded:
                                    !patientMedicationInfo.ctScan.isUploaded,
                                },
                              });
                            }}
                          />
                        </Tooltip>
                      </div>
                    </div>
                  </div>
                  {renderSelectedFileLine("CT_SCAN_FILE")}
                  </div>

                  <div className={INVESTIGATION_ENTRY_CLASS}>
                  <div className="investigation-upload-row flex w-full">
                    <div className="py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] flex-shrink-0 bg-[#f0f0f0] flex-1 rounded-s-full border-2 border-[#d4d4d4] flex items-center">
                      <h3 className="text-black font-[500] 2xl:text-[1dvw] xl:text-[1dvw] lg:text-[1dvw] md:text-[1dvw] text-[3.5dvw]">
                        X-RAYS
                      </h3>
                    </div>
                    <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] flex-shrink-0 border-l-0 bg-[#f0f0f0] border-2 border-[#d4d4d4] flex items-center">
                      <input
                        placeholder="Enter Region"
                        value={patientMedicationInfo.xRay.region}
                        onChange={(e) => {
                          setPatientMedicationInfo({
                            ...patientMedicationInfo,
                            xRay: {
                              region: e.target.value,
                            },
                          });
                        }}
                        className="bg-transparent border-none outline-none focus:border-none active:border-none  w-full"
                      />
                    </div>
                    <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] flex-shrink-0 border-l-0 bg-[#f0f0f0] border-2 border-[#d4d4d4] flex items-center">
                      <input
                        type="date"
                        value={patientMedicationInfo.xRay.region}
                        onChange={(e) => {
                          setPatientMedicationInfo({
                            ...patientMedicationInfo,
                            xRay: {
                              region: e.target.value,
                            },
                          });
                        }}
                        className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                        placeholder="Enter Treatment"
                      />
                    </div>

                    <div className={`${INVESTIGATION_UPLOAD_COLUMN_GRAY} flex-shrink-0`}>
                      <div className="flex justify-center items-stretch gap-2.5 w-full">
                        <Tooltip title="Create an Account and Upload images">
                          <a
                            href="https://blume.omegaai.com/"
                            target="_blank"
                            className="flex justify-center items-center w-full rounded-lg BTNGradientBg py-2 gap-1.5 text-[#fff]"
                          >
                            Upload to Blume
                          </a>
                        </Tooltip>
                        {renderLocalUploadButton("X_RAYS_FILE")}
                        <Tooltip title="Mark as Uploaded">
                          <input
                            className=" w-7 h-7"
                            type="checkbox"
                            value="uploaded"
                            checked={patientMedicationInfo.xRay.isUploaded}
                            onChange={(e) => {
                              setPatientMedicationInfo({
                                ...patientMedicationInfo,
                                xRay: {
                                  ...patientMedicationInfo.xRay,
                                  isUploaded:
                                    !patientMedicationInfo.xRay.isUploaded,
                                },
                              });
                            }}
                          />
                        </Tooltip>
                      </div>
                    </div>
                  </div>
                  {renderSelectedFileLine("X_RAYS_FILE")}
                  </div>

                  <div className={INVESTIGATION_ENTRY_CLASS}>
                  <div className="investigation-upload-row flex w-full">
                    <div className="py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] bg-[#f0f0f0] flex-1 rounded-s-full border-2 border-[#d4d4d4] flex items-center">
                      <h3 className="text-black font-[500] 2xl:text-[1dvw] xl:text-[1dvw] lg:text-[1dvw] md:text-[1dvw] text-[3.5dvw]">
                        EMG-NCV
                      </h3>
                    </div>
                    <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] border-l-0 bg-[#f0f0f0] border-2 border-[#d4d4d4] flex items-center">
                      <input
                        placeholder="Enter Region"
                        value={patientMedicationInfo.EMGNCV.region}
                        onChange={(e) => {
                          setPatientMedicationInfo({
                            ...patientMedicationInfo,
                            EMGNCV: {
                              region: e.target.value,
                            },
                          });
                        }}
                        className="bg-transparent border-none outline-none focus:border-none active:border-none  w-full"
                      />
                    </div>
                    <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] border-l-0 bg-[#f0f0f0] border-2 border-[#d4d4d4] flex items-center">
                      <input
                        type="date"
                        className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                        placeholder="Enter Treatment"
                        value={patientMedicationInfo.EMGNCV.date}
                        onChange={(e) => {
                          setPatientMedicationInfo({
                            ...patientMedicationInfo,
                            EMGNCV: {
                              date: e.target.value,
                            },
                          });
                        }}
                      />
                    </div>

                    <div className={INVESTIGATION_UPLOAD_COLUMN_GRAY}>
                      <div className="flex justify-center items-stretch gap-2.5 w-full">
                        <Tooltip title="Create an Account and Upload images">
                          <a
                            href="https://blume.omegaai.com/"
                            target="_blank"
                            className="flex justify-center items-center w-full rounded-lg BTNGradientBg py-2 gap-1.5 text-[#fff]"
                          >
                            Upload to Blume
                          </a>
                        </Tooltip>
                        {renderLocalUploadButton("EMG_NCV_FILE")}
                        <Tooltip title="Mark as Uploaded">
                          <input
                            className="w-7 h-7"
                            type="checkbox"
                            value="uploaded"
                            checked={patientMedicationInfo.EMGNCV.isUploaded}
                            onChange={(e) => {
                              setPatientMedicationInfo({
                                ...patientMedicationInfo,
                                EMGNCV: {
                                  ...patientMedicationInfo.EMGNCV,
                                  isUploaded:
                                    !patientMedicationInfo.EMGNCV.isUploaded,
                                },
                              });
                            }}
                          />
                        </Tooltip>
                      </div>
                    </div>
                  </div>
                  {renderSelectedFileLine("EMG_NCV_FILE")}
                  </div>

                  <div className={INVESTIGATION_ENTRY_CLASS}>
                  <div className="investigation-upload-row flex w-full">
                    <div className="py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] bg-[#f0f0f0] flex-1 rounded-s-full border-2 border-[#d4d4d4] flex items-center">
                      <h3 className="text-black font-[500] 2xl:text-[1dvw] xl:text-[1dvw] lg:text-[1dvw] md:text-[1dvw] text-[3.5dvw]">
                        Vascular studies
                      </h3>
                    </div>
                    <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] border-l-0 bg-[#f0f0f0] border-2 border-[#d4d4d4] flex items-center">
                      <input
                        placeholder="Enter Region"
                        value={patientMedicationInfo.vascularStudies.region}
                        onChange={(e) => {
                          setPatientMedicationInfo({
                            ...patientMedicationInfo,
                            vascularStudies: {
                              region: e.target.value,
                            },
                          });
                        }}
                        className="bg-transparent border-none outline-none focus:border-none active:border-none  w-full"
                      />
                    </div>
                    <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] border-l-0 bg-[#f0f0f0] border-2 border-[#d4d4d4] flex items-center">
                      <input
                        type="date"
                        className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                        placeholder="Enter Treatment"
                        value={patientMedicationInfo.vascularStudies.date}
                        onChange={(e) => {
                          setPatientMedicationInfo({
                            ...patientMedicationInfo,
                            vascularStudies: {
                              date: e.target.value,
                            },
                          });
                        }}
                      />
                    </div>

                    <div className={INVESTIGATION_UPLOAD_COLUMN_GRAY}>
                      <div className="flex justify-center items-stretch gap-2.5 w-full">
                        <Tooltip title="Create an Account and Upload images">
                          <a
                            href="https://blume.omegaai.com/"
                            target="_blank"
                            className="flex justify-center items-center w-full rounded-lg BTNGradientBg py-2 gap-1.5 text-[#fff]"
                          >
                            Upload to Blume
                          </a>
                        </Tooltip>
                        {renderLocalUploadButton("VASCULAR_STUDIES_FILE")}
                        <Tooltip title="Mark as Uploaded">
                          <input
                            className=" w-7 h-7"
                            type="checkbox"
                            value="uploaded"
                            checked={
                              patientMedicationInfo.vascularStudies.isUploaded
                            }
                            onChange={(e) => {
                              setPatientMedicationInfo({
                                ...patientMedicationInfo,
                                vascularStudies: {
                                  ...patientMedicationInfo.vascularStudies,
                                  isUploaded:
                                    !patientMedicationInfo.vascularStudies
                                      .isUploaded,
                                },
                              });
                            }}
                          />
                        </Tooltip>
                      </div>
                    </div>
                  </div>
                  {renderSelectedFileLine("VASCULAR_STUDIES_FILE")}
                  </div>

                  <div className={INVESTIGATION_ENTRY_CLASS}>
                  <div className="investigation-upload-row flex w-full">
                    <div className="py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] bg-[#f0f0f0] flex-1 rounded-s-full border-2 border-[#d4d4d4] flex items-center">
                      <h3 className="text-black font-[500] 2xl:text-[1dvw] xl:text-[1dvw] lg:text-[1dvw] md:text-[1dvw] text-[3.5dvw]">
                        DEXA scan
                      </h3>
                    </div>
                    <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] border-l-0 bg-[#f0f0f0] border-2 border-[#d4d4d4] flex items-center">
                      <input
                        placeholder="Enter Region"
                        value={patientMedicationInfo.dexaScan.region}
                        onChange={(e) => {
                          setPatientMedicationInfo({
                            ...patientMedicationInfo,
                            dexaScan: {
                              region: e.target.value,
                            },
                          });
                        }}
                        className="bg-transparent border-none outline-none focus:border-none active:border-none  w-full"
                      />
                    </div>
                    <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] border-l-0 bg-[#f0f0f0] border-2 border-[#d4d4d4] flex items-center">
                      <input
                        type="date"
                        className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                        placeholder="Enter Treatment"
                        value={patientMedicationInfo.dexaScan.date}
                        onChange={(e) => {
                          setPatientMedicationInfo({
                            ...patientMedicationInfo,
                            dexaScan: {
                              date: e.target.value,
                            },
                          });
                        }}
                      />
                    </div>

                    <div className={INVESTIGATION_UPLOAD_COLUMN_GRAY}>
                      <div className="flex justify-center items-stretch gap-2.5 w-full">
                        <Tooltip title="Create an Account and Upload images">
                          <a
                            href="https://blume.omegaai.com/"
                            target="_blank"
                            className="flex justify-center items-center w-full rounded-lg BTNGradientBg py-2 gap-1.5 text-[#fff]"
                          >
                            Upload to Blume
                          </a>
                        </Tooltip>
                        {renderLocalUploadButton("DEXA_SCAN_FILE")}
                        <Tooltip title="Mark as Uploaded">
                          <input
                            className=" w-7 h-7"
                            type="checkbox"
                            value="uploaded"
                            checked={patientMedicationInfo.dexaScan.isUploaded}
                            onChange={(e) => {
                              setPatientMedicationInfo({
                                ...patientMedicationInfo,
                                dexaScan: {
                                  ...patientMedicationInfo.dexaScan,
                                  isUploaded:
                                    !patientMedicationInfo.dexaScan.isUploaded,
                                },
                              });
                            }}
                          />
                        </Tooltip>
                      </div>
                    </div>
                  </div>
                  {renderSelectedFileLine("DEXA_SCAN_FILE")}
                  </div>

                  <div className={INVESTIGATION_ENTRY_CLASS}>
                  <div className="investigation-upload-row flex w-full">
                    <div className="py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] bg-[#f0f0f0] flex-1 rounded-s-full border-2 border-[#d4d4d4] flex items-center">
                      <h3 className="text-black font-[500] 2xl:text-[1dvw] xl:text-[1dvw] lg:text-[1dvw] md:text-[1dvw] text-[3.5dvw]">
                        Myelogram
                      </h3>
                    </div>
                    <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] border-l-0 bg-[#f0f0f0] border-2 border-[#d4d4d4] flex items-center">
                      <input
                        placeholder="Enter Region"
                        value={patientMedicationInfo.myelogram.region}
                        onChange={(e) => {
                          setPatientMedicationInfo({
                            ...patientMedicationInfo,
                            myelogram: {
                              region: e.target.value,
                            },
                          });
                        }}
                        className="bg-transparent border-none outline-none focus:border-none active:border-none  w-full"
                      />
                    </div>
                    <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] border-l-0 bg-[#f0f0f0] border-2 border-[#d4d4d4] flex items-center">
                      <input
                        type="date"
                        className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                        placeholder="Enter Treatment"
                        value={patientMedicationInfo.myelogram.date}
                        onChange={(e) => {
                          setPatientMedicationInfo({
                            ...patientMedicationInfo,
                            myelogram: {
                              date: e.target.value,
                            },
                          });
                        }}
                      />
                    </div>

                    <div className={INVESTIGATION_UPLOAD_COLUMN_GRAY}>
                      <div className="flex justify-center items-stretch gap-2.5 w-full">
                        <Tooltip title="Create an Account and Upload images">
                          <a
                            href="https://blume.omegaai.com/"
                            target="_blank"
                            className="flex justify-center items-center w-full rounded-lg BTNGradientBg py-2 gap-1.5 text-[#fff]"
                          >
                            Upload to Blume
                          </a>
                        </Tooltip>
                        {renderLocalUploadButton("MYELOGRAM_FILE")}
                        <Tooltip title="Mark as Uploaded">
                          <input
                            className=" w-7 h-7"
                            type="checkbox"
                            value="uploaded"
                            checked={patientMedicationInfo.myelogram.isUploaded}
                            onChange={(e) => {
                              setPatientMedicationInfo({
                                ...patientMedicationInfo,
                                myelogram: {
                                  ...patientMedicationInfo.myelogram,
                                  isUploaded:
                                    !patientMedicationInfo.myelogram.isUploaded,
                                },
                              });
                            }}
                          />
                        </Tooltip>
                      </div>
                    </div>
                  </div>
                  {renderSelectedFileLine("MYELOGRAM_FILE")}
                  </div>

                  <div className={INVESTIGATION_ENTRY_CLASS}>
                  <div className="investigation-upload-row flex w-full">
                    <div className="py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] bg-[#f0f0f0] flex-1 rounded-s-full border-2 border-[#d4d4d4] flex items-center">
                      <h3 className="text-black font-[500] 2xl:text-[1dvw] xl:text-[1dvw] lg:text-[1dvw] md:text-[1dvw] text-[3.5dvw]">
                        Discogram
                      </h3>
                    </div>
                    <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] border-l-0 bg-[#f0f0f0] border-2 border-[#d4d4d4] flex items-center">
                      <input
                        placeholder="Enter Region"
                        value={patientMedicationInfo.discogram.region}
                        onChange={(e) => {
                          setPatientMedicationInfo({
                            ...patientMedicationInfo,
                            discogram: {
                              region: e.target.value,
                            },
                          });
                        }}
                        className="bg-transparent border-none outline-none focus:border-none active:border-none  w-full"
                      />
                    </div>
                    <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] border-l-0 bg-[#f0f0f0] border-2 border-[#d4d4d4] flex items-center">
                      <input
                        type="date"
                        className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                        placeholder="Enter Treatment"
                        value={patientMedicationInfo.discogram.date}
                        onChange={(e) => {
                          setPatientMedicationInfo({
                            ...patientMedicationInfo,
                            discogram: {
                              date: e.target.value,
                            },
                          });
                        }}
                      />
                    </div>

                    <div className={INVESTIGATION_UPLOAD_COLUMN_GRAY}>
                      <div className="flex justify-center items-stretch gap-2.5 w-full">
                        <Tooltip title="Create an Account and Upload images">
                          <a
                            href="https://blume.omegaai.com/"
                            target="_blank"
                            className="flex justify-center items-center w-full rounded-lg BTNGradientBg py-2 gap-1.5 text-[#fff]"
                          >
                            Upload to Blume
                          </a>
                        </Tooltip>
                        {renderLocalUploadButton("DISCOGRAM_FILE")}
                        <Tooltip title="Mark as Uploaded">
                          <input
                            className=" w-7 h-7"
                            type="checkbox"
                            value="uploaded"
                            checked={patientMedicationInfo.discogram.isUploaded}
                            onChange={(e) => {
                              setPatientMedicationInfo({
                                ...patientMedicationInfo,
                                discogram: {
                                  ...patientMedicationInfo.discogram,
                                  isUploaded:
                                    !patientMedicationInfo.discogram.isUploaded,
                                },
                              });
                            }}
                          />
                        </Tooltip>
                      </div>
                    </div>
                  </div>
                  {renderSelectedFileLine("DISCOGRAM_FILE")}
                  </div>

                  <div className={INVESTIGATION_ENTRY_CLASS}>
                  <div className="investigation-upload-row flex w-full">
                    <div className="py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] bg-[#f0f0f0] flex-1 rounded-s-full border-2 border-[#d4d4d4] flex items-center">
                      <h3 className="text-black font-[500] 2xl:text-[1dvw] xl:text-[1dvw] lg:text-[1dvw] md:text-[1dvw] text-[3.5dvw]">
                        PET Scan
                      </h3>
                    </div>
                    <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] border-l-0 bg-[#f0f0f0] border-2 border-[#d4d4d4] flex items-center">
                      <input
                        placeholder="Enter Region"
                        value={patientMedicationInfo.petScan.region}
                        onChange={(e) => {
                          setPatientMedicationInfo({
                            ...patientMedicationInfo,
                            petScan: {
                              region: e.target.value,
                            },
                          });
                        }}
                        className="bg-transparent border-none outline-none focus:border-none active:border-none  w-full"
                      />
                    </div>
                    <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] border-l-0 bg-[#f0f0f0] border-2 border-[#d4d4d4] flex items-center">
                      <input
                        type="date"
                        className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                        placeholder="Enter Treatment"
                        value={patientMedicationInfo.petScan.date}
                        onChange={(e) => {
                          setPatientMedicationInfo({
                            ...patientMedicationInfo,
                            petScan: {
                              date: e.target.value,
                            },
                          });
                        }}
                      />
                    </div>

                    <div className={INVESTIGATION_UPLOAD_COLUMN_GRAY}>
                      <div className="flex justify-center items-stretch gap-2.5 w-full">
                        <Tooltip title="Create an Account and Upload images">
                          <a
                            href="https://blume.omegaai.com/"
                            target="_blank"
                            className="flex justify-center items-center w-full rounded-lg BTNGradientBg py-2 gap-1.5 text-[#fff]"
                          >
                            Upload to Blume
                          </a>
                        </Tooltip>
                        {renderLocalUploadButton("PET_SCAN_FILE")}
                        <Tooltip title="Mark as Uploaded">
                          <input
                            className="w-7 h-7"
                            type="checkbox"
                            value="uploaded"
                            checked={patientMedicationInfo.petScan.isUploaded}
                            onChange={(e) => {
                              setPatientMedicationInfo({
                                ...patientMedicationInfo,
                                petScan: {
                                  ...patientMedicationInfo.petScan,
                                  isUploaded:
                                    !patientMedicationInfo.petScan.isUploaded,
                                },
                              });
                            }}
                          />
                        </Tooltip>
                      </div>
                    </div>
                  </div>
                  {renderSelectedFileLine("PET_SCAN_FILE")}
                  </div>
                </div>
              </div>
            </div>

            <div className="my-8">
              <h3 className="font-mainFont font-[600] text-black 2xl:text-[1.3vw] xl:text-[1.3vw] lg:text-[1.3vw] md:text-[1.3vw] text-[3.5vw]">
                Other Diagnostic Testing
              </h3>
              <div className="flex flex-col 2xl:flex-row xl:flex-row lg:flex-row md:flex-col justify-start 2xl:w-[70%] xl:w-[70%] lg:w-[70%] md:w-[70%] w-[100%] my-3 gap-3">
                <div className="flex-1">
                  <input
                    className=" w-full bg-[#f0f0f0] px-6 py-3 rounded-full border outline-none border-[#d4d4d4] font-mainFont font-[500] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] placeholder:text-[#333333]/50 text-mainColor "
                    placeholder="Enter Other Diagnostic Testing"
                    onChange={(e) => {
                      setPatientMedicationInfo({
                        ...patientMedicationInfo,
                        otherDiagnosticTesting: e.target.value,
                      });
                    }}
                    value={patientMedicationInfo.otherDiagnosticTesting}
                  />
                </div>
                <div className="flex-1">
                  <input
                    className=" w-full bg-[#f0f0f0] px-6 py-3 rounded-full border outline-none border-[#d4d4d4] font-mainFont font-[500] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] placeholder:text-[#333333]/50 text-mainColor "
                    placeholder="Enter Date"
                    type="date"
                    onChange={(e) => {
                      setPatientMedicationInfo({
                        ...patientMedicationInfo,
                        otherDiagnosticTestingDate: e.target.value,
                      });
                    }}
                    value={patientMedicationInfo.otherDiagnosticTestingDate}
                  />
                </div>
              </div>
              <div className="2xl:w-[70%] xl:w-[70%] lg:w-[70%] md:w-[70%] w-[100%] my-5">
                <div className="flex justify-start items-center gap-3">
                  <input
                    type="checkbox"
                    id="noDiagnosticTests"
                    name="noDiagnosticTests"
                    checked={patientMedicationInfo.noDiagnosticTests === true || patientMedicationInfo.noDiagnosticTests === "true"}
                    onChange={(e) => {
                      setPatientMedicationInfo({
                        ...patientMedicationInfo,
                        noDiagnosticTests: e.target.checked,
                        // If checked, clear other diagnostic testing fields
                        ...(e.target.checked ? {
                          otherDiagnosticTesting: "",
                          otherDiagnosticTestingDate: "",
                        } : {}),
                      });
                    }}
                  />
                  <label
                    htmlFor="noDiagnosticTests"
                    className="font-mainFont font-[400] 2xl:text-[1.05vw] xl:text-[1.05vw] lg:text-[1.05vw] md:text-[1.05vw] text-[3.5vw] text-black cursor-pointer"
                  >
                    I have not had ANY diagnostic tests for my current pain
                    complaint
                  </label>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
